var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3643 0.000517605C11.5047 0.040913 11.6497 0.0657717 11.7812 0.12274C15.3381 1.66035 18.8934 3.20108 22.4472 4.74542C22.5337 4.78323 22.6 4.86713 22.6756 4.92927C22.5943 4.99556 22.5233 5.08723 22.4301 5.12452C18.8903 6.54613 15.3485 7.96204 11.8076 9.38054C11.4964 9.50535 11.1945 9.51001 10.8806 9.38416C7.37244 7.97654 3.86322 6.57254 0.354518 5.16699C0.306872 5.14782 0.254047 5.13591 0.212616 5.10691C0.139593 5.05616 0.0733035 4.99556 0.00390625 4.93911C0.0748571 4.87386 0.13545 4.78323 0.219348 4.74698C3.79693 3.19227 7.37658 1.64223 10.9573 0.0952915C11.08 0.0424668 11.2214 0.0321092 11.3638 0L11.3643 0.000517605Z",
    fill: "url(#paint0_linear_1551_36441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M11.3143 14.5075C11.1693 14.4676 11.0155 14.4407 10.8741 14.3843C7.33177 12.9694 3.79095 11.5519 0.251176 10.1303C0.156921 10.0925 0.0833803 10.004 0 9.93922C0.0833803 9.87345 0.157956 9.78644 0.252212 9.74501C1.57387 9.16498 2.89708 8.58701 4.22494 8.02147C4.34199 7.97176 4.51444 7.97072 4.63356 8.01785C6.5829 8.78743 8.52964 9.5653 10.4733 10.3494C11.0544 10.5835 11.6183 10.5845 12.201 10.3494C14.1363 9.56738 16.0774 8.79986 18.0138 8.01992C18.179 7.95363 18.3136 7.95311 18.4768 8.0251C19.7984 8.60565 21.1242 9.17585 22.4459 9.75537C22.5318 9.79318 22.5976 9.87759 22.6732 9.94026C22.5976 10.0019 22.5318 10.0879 22.4459 10.1226C18.8823 11.5535 15.3171 12.9808 11.7504 14.4045C11.6168 14.4578 11.4687 14.4728 11.3143 14.5086V14.5075Z",
    fill: "url(#paint1_linear_1551_36441)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.339 19.515C11.1779 19.471 11.0163 19.443 10.8672 19.3834C7.3248 17.9696 3.78347 16.5537 0.244207 15.1326C0.152541 15.0958 0.0831434 15.0031 0.00390625 14.9363C0.0810718 14.8752 0.149433 14.7939 0.236439 14.7561C1.57467 14.1704 2.91393 13.5877 4.25785 13.0155C4.36039 12.972 4.51214 12.9766 4.61779 13.0181C6.55055 13.783 8.48228 14.5505 10.4083 15.3325C11.0427 15.5899 11.6502 15.5852 12.2836 15.3273C14.2008 14.5474 16.1248 13.782 18.0498 13.0217C18.1679 12.9751 18.3403 12.9808 18.4584 13.031C19.7635 13.5846 21.0623 14.1522 22.3633 14.7162C22.4026 14.7333 22.4477 14.7447 22.4793 14.7711C22.5476 14.8276 22.6093 14.8923 22.6735 14.9534C22.6036 15.0109 22.543 15.0901 22.4632 15.1228C21.1887 15.6376 19.9121 16.1466 18.636 16.6568C16.3625 17.5657 14.0895 18.4751 11.8149 19.3809C11.6657 19.4404 11.5042 19.4689 11.3395 19.5145L11.339 19.515Z",
    fill: "url(#paint2_linear_1551_36441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1551_36441",
    x1: -1.51651,
    y1: 1.34375,
    x2: 3.11118,
    y2: 15.1831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1551_36441",
    x1: -1.52052,
    y1: 8.89772,
    x2: 0.804595,
    y2: 18.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1551_36441",
    x1: -1.51637,
    y1: 13.9108,
    x2: 0.80382,
    y2: 23.9791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28123"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackColor);
export default __webpack_public_path__ + "static/media/StackColor.510024f6a334545740a002d16a038f45.svg";
export { ForwardRef as ReactComponent };